// ─────────────────────────────────────────────
//  PercentageAmountInput.jsx — Monto base
// ─────────────────────────────────────────────

import React, { useRef, useEffect } from 'react';
import styles from './PercentageAmountInput.module.css';

export default function PercentageAmountInput({ value, onChange, onReset, autoFocus = false }) {
	const inputRef = useRef(null);

	useEffect(() => {
		if (!autoFocus) return;

		const focusInput = () => {
			inputRef.current?.focus({ preventScroll: true });
		};

		focusInput();
		requestAnimationFrame(focusInput);
		const timer = window.setTimeout(focusInput, 100);

		return () => window.clearTimeout(timer);
	}, [autoFocus]);

	const handleReset = () => {
		onReset?.();
		inputRef.current?.focus();
	};

	const handleChange = (e) => {
		const raw = e.target.value;
		const sanitized = raw.replace(/[^0-9.]/g, '');
		const parts = sanitized.split('.');
		if (parts.length > 2) return;
		if (parts[1] !== undefined && parts[1].length > 2) return;
		if (parseFloat(sanitized) > 99999999.99) return;
		onChange(sanitized);
	};

	return (
		<section className={styles.card} aria-label="Monto base">
			{value ? (
				<button
					type="button"
					className={`${styles.resetBtn} ${styles.label}`}
					onClick={handleReset}
					aria-label="Reiniciar calculadora"
				>
					<span>↺</span> Reiniciar
				</button>
			) : null}

			<div
				className={styles.inputWrap}
				onClick={() => inputRef.current?.focus()}
			>
				<span className={styles.currency} aria-hidden="true">$</span>
				<input
					ref={inputRef}
					className={styles.input}
					type="text"
					inputMode="decimal"
					value={value}
					placeholder="Ingresa el monto"
					aria-label="Monto base en dólares"
					onChange={handleChange}
				/>
			</div>
		</section>
	);
}
